import React from "react";
import { cancelledOrderAnalysis } from "../../../Action/courseAction";
import { OrderDayPage, countOf, pctOf } from "../../Common/orderAnalysisCommon";


const CancelledAnalysis = () => (
  <OrderDayPage
    pageTitle="Cancelled Analysis"
    tableId="cancelled-analysis"
    fetchAction={cancelledOrderAnalysis} // same request as before
    parse={(res) => ({ rows: res?.data?.result, summary: res?.data?.totalSummary })}
    dateKey="date"
    columns={[
      { key: "totalExitPaymentOrders", header: "Total Exit Payment Orders", kind: "list", listTitle: "Total Exit Payment Orders Details", minWidth: 140 },
      { key: "couponConversion", header: "Coupon Conversion (%)", kind: "pct" },
      { key: "dayConversion", header: "Day Conversion (%)", kind: "pct" },
      { key: "totalCancelledOrders", header: "Total Cancelled Orders", kind: "count" },
      { key: "totalExitCoupons", header: "Total Exit Coupons", kind: "count" },
      { key: "totalExitPaymentCount", header: "Total Exit Payment Count", kind: "count" },
      { key: "otherThanExitPaymentOrders", header: "Other Than Exit Payment Orders", kind: "list", listTitle: "Other Than Exit Payment Orders Details", minWidth: 150 },
    ]}
    summaryGroups={(s) => [
      {
        title: "Total",
        tone: "primary",
        metrics: [
          { label: "Exit Coupons", value: countOf(s.totalExitCoupons) },
          { label: "Day Conversion", value: pctOf(s.dayConversion) },
        ],
      },
      {
        title: "Exit Payment",
        tone: "pink",
        metrics: [
          { label: "Exit Payments", value: countOf(s.totalExitPaymentCount) },
          { label: "Other Exit Orders", value: countOf(Array.isArray(s.otherThanExitPaymentOrders) ? s.otherThanExitPaymentOrders.length : s.otherThanExitPaymentOrders) },
        ],
      },
      { title: "Coupon", tone: "success", metrics: [{ label: "Coupon Conversion", value: pctOf(s.couponConversion) }] },
    ]}
    userColumns={["firstName", "lastName", "mobileNo", "orderNo", "orderDate", "couponName", "whatsapp"]}
  />
);

export default CancelledAnalysis;
